import { useCurrentUser } from "../../../lib/api/users.api";
import { SectionLabel, ToggleRow } from "./SettingsUIComponents";

interface AdvancedModeSectionProps {
  readonly advancedMode: boolean;
  readonly onAdvancedMode: () => void;
  readonly googleCalendarUi: boolean;
  readonly onGoogleCalendarUi: () => void;
  readonly settingsCollapsed: boolean;
  readonly onSettingsCollapsed: () => void;
  readonly desktopBottomBar: boolean;
  readonly onDesktopBottomBar: () => void;
}

export function AdvancedModeSection({
  advancedMode,
  onAdvancedMode,
  googleCalendarUi,
  onGoogleCalendarUi,
  settingsCollapsed,
  onSettingsCollapsed,
  desktopBottomBar,
  onDesktopBottomBar,
}: AdvancedModeSectionProps) {
  const { data: user } = useCurrentUser();
  const isAdmin = user?.role === "ADMIN";

  return (
    <div className="flex flex-col gap-1 border-t border-border pt-4">
      <SectionLabel>Interface</SectionLabel>
      <ToggleRow
        label="UI Google Calendar"
        description="Layout alternatif avec sidebar à gauche"
        checked={googleCalendarUi}
        onChange={onGoogleCalendarUi}
        badge="Bêta"
      />
      <ToggleRow
        label="Bottom bar desktop"
        description="Remplacer la sidebar par une barre de navigation en bas"
        checked={desktopBottomBar}
        onChange={onDesktopBottomBar}
        badge="Bêta"
      />
      <ToggleRow
        label="Sections repliées"
        description="Replier les catégories des paramètres par défaut"
        checked={settingsCollapsed}
        onChange={onSettingsCollapsed}
      />
      {isAdmin && (
        <div className="mt-4">
          <SectionLabel>Fonctionnalités</SectionLabel>
          <ToggleRow
            label="Mode avancé"
            description="Kanban, Eisenhower et Journal"
            checked={advancedMode}
            onChange={onAdvancedMode}
            badge="Beta"
          />
        </div>
      )}
    </div>
  );
}
